"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionOrdinalResults = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const ChoiceResultRow_1 = require("../components/ChoiceResultRow");
const surveyHelpers_1 = require("../utils/surveyHelpers");
const QuestionOrdinalResults = (surveyResponses, question, anonymityLevel, applicationType, maxChoiceCount) => {
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, { separator: true });
    const questionResponses = (0, surveyHelpers_1.getQuestionResponses)(surveyResponses, question.id);
    let totalVotes = 0;
    let choiceList = question.choices.map(choice => {
        const votes = questionResponses
            .filter(r => {
            return Array.isArray(r.response.value)
                ? r.response.value.indexOf(choice.id) > -1
                : r.response.value === choice.id;
        })
            .sort(surveyHelpers_1.questionResponseSort);
        totalVotes += votes.length;
        return {
            choice,
            votes: votes.length,
            users: votes.map(v => v.user.name),
        };
    });
    const averagedSum = choiceList.reduce((sum, choice) => {
        return sum + choice.votes * choice.choice.value;
    }, 0);
    const average = totalVotes > 0 ? (averagedSum / totalVotes).toFixed(1) : 0;
    if (maxChoiceCount !== undefined && choiceList.length > maxChoiceCount) {
        choiceList = choiceList.sort((a, b) => b.votes - a.votes).slice(0, maxChoiceCount);
    }
    if (question.renderAs === "nps") {
        generateNpsDetails(container, maxChoiceCount, choiceList, totalVotes, anonymityLevel, applicationType);
    }
    else {
        choiceList.forEach(choiceResult => {
            container.addItem((0, ChoiceResultRow_1.ChoiceResultRow)(choiceResult.choice.label, choiceResult.votes, totalVotes, choiceResult.users, anonymityLevel, applicationType, maxChoiceCount !== undefined));
        });
    }
    const bottomRow = CardHelper_1.CardHelper.create(adaptivecards_1.ColumnSet, {
        separator: true,
        spacing: adaptivecards_1.Spacing.Large,
    });
    const leftcol = CardHelper_1.CardHelper.create(adaptivecards_1.Column, {
        width: "stretch",
    });
    leftcol.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `Total Votes: ${totalVotes}`,
        weight: adaptivecards_1.TextWeight.Bolder,
    }));
    bottomRow.addColumn(leftcol);
    const rightCol = CardHelper_1.CardHelper.create(adaptivecards_1.Column, {
        width: "auto",
    });
    if (question.renderAs === "nps") {
        const npsScore = (0, surveyHelpers_1.calculateNpsScore)(question.choices, questionResponses);
        rightCol.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: `NPS: ${npsScore.nps}`,
            weight: adaptivecards_1.TextWeight.Bolder,
            horizontalAlignment: adaptivecards_1.HorizontalAlignment.Right,
        }));
        if (maxChoiceCount !== undefined) {
            const npsContainer = generateNpsSummary(npsScore, anonymityLevel, applicationType, maxChoiceCount);
            container.addItem(npsContainer);
        }
        bottomRow.addColumn(rightCol);
        container.addItem(bottomRow);
    }
    else {
        rightCol.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: `Avg: ${average}`,
            weight: adaptivecards_1.TextWeight.Bolder,
            horizontalAlignment: adaptivecards_1.HorizontalAlignment.Right,
        }));
        bottomRow.addColumn(rightCol);
        container.addItem(bottomRow);
    }
    return container;
};
exports.QuestionOrdinalResults = QuestionOrdinalResults;
function generateNpsDetails(container, maxChoiceCount, choiceList, totalVotes, anonymityLevel, applicationType) {
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `NPS Breakdown`,
        weight: adaptivecards_1.TextWeight.Bolder,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Left,
        color: adaptivecards_1.TextColor.Accent,
        separator: true,
    }));
    if (maxChoiceCount === undefined) {
        const NPS_LEVELS = [
            [0, "Detractors"],
            [7, "Passives"],
            [9, "Promoters"],
        ];
        choiceList.forEach(choiceResult => {
            const npsLevelThreshold = NPS_LEVELS.find(level => level[0] === choiceResult.choice.value);
            npsLevelThreshold &&
                container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
                    text: npsLevelThreshold[1],
                    weight: adaptivecards_1.TextWeight.Bolder,
                    separator: true,
                }));
            container.addItem((0, ChoiceResultRow_1.ChoiceResultRow)(choiceResult.choice.label, choiceResult.votes, totalVotes, choiceResult.users, anonymityLevel, applicationType, maxChoiceCount !== undefined, undefined, (0, surveyHelpers_1.getNpsCategory)(choiceResult.choice.value)));
        });
    }
}
function generateNpsSummary(npsScore, anonymityLevel, applicationType, maxChoiceCount) {
    const npsContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, { spacing: adaptivecards_1.Spacing.Large, separator: true });
    npsContainer.addItem((0, ChoiceResultRow_1.ChoiceResultRow)("Detractors", npsScore.detractors.length, npsScore.totalVotes, npsScore.detractors, anonymityLevel, applicationType, maxChoiceCount !== undefined, undefined, "detractor"));
    npsContainer.addItem((0, ChoiceResultRow_1.ChoiceResultRow)("Passives", npsScore.passives.length, npsScore.totalVotes, npsScore.passives, anonymityLevel, applicationType, maxChoiceCount !== undefined, undefined, "passive"));
    npsContainer.addItem((0, ChoiceResultRow_1.ChoiceResultRow)("Promoters", npsScore.promoters.length, npsScore.totalVotes, npsScore.promoters, anonymityLevel, applicationType, maxChoiceCount !== undefined, undefined, "promoter"));
    return npsContainer;
}
//# sourceMappingURL=QuestionOrdinalResult.js.map